export default {
  successPopup: {
    title: 'Регистрация прошла успешно!',
    description: 'Письмо с паролем отправлено вам на указанный e-mail адрес.',
    button: 'Авторизоваться'
  },
  emailTaken: 'Этот адрес эл. почты уже используется в другой учётной записи.',
  hasAccount: 'Уже есть аккаунт?',
  registration: 'Регистрация',
  agreeWithPrivacyPolicy: 'Соглашаюсь с',
  agreeWithPrivacyPolicyLink: 'политикой конфиденциальности',
  notSelected: '- не выбрано -',
  additionalInfo: 'Дополнительная информация',
  specialisationNotSelected: '- специализация не выбрана -',
  maybeSpam: 'Не нашли письмо?<br>Скорее всего оно попало в папку «Спам».',
  success: 'Успешно',
  instructions: 'Мы отправили письмо с паролем <br>на Вашу электронную почту',
  bim: '© ООО «ИНФОРМАЦИОННЫЕ ТЕХНОЛОГИИ МАРКЕТИНГА»',
  agreement: 'Пользовательское соглашение',
  privacyPolicy: 'Политика конфиденциальности',
  uploadImg: 'Перетащите изображение или нажмите на область',
  uploadTitle: 'Загрузка изображения',
  uploadDesc: 'Макс. 2.5МБ, минимальное разрешение (150x150), формат: .jpeg, .jpg, .png',
  acceptAccount: 'Аккаунт подтвержден',
  redirectText: 'Команда BIMLIB желает вам хорошего настроения :) Перенаправляем на главную страницу через…',
  goNow: 'Перейти сейчас',
  buttons: {
    add: 'Добавить',
    save: 'Сохранить',
    accept: 'Подтвердить',
    cancel: 'Отменить',
    remove: 'Удалить',
    link: 'Привязать',
    import: 'Импортировать',
    continue: 'Продолжить',
    skip: 'Пропустить',
    finish: 'Завершить'
  },
  back: 'Назад',
  next: 'Продолжить',
  skip: 'Пропустить шаг',
  step: 'шаг',
  of: 'из',
  emailConfirmed: 'Email подтвержден',
  continue: 'Продолжить',
  createAccount: 'Создание аккаунта',
  mobilePhone: 'Мобильный телефон',
  selectRole: 'Выберите роль',
  selectUserRole: 'Роль пользователя',
  manufacturer: 'Производитель',
  designer: 'Проектировщик',
  other: 'Иное',
  estimator: 'Сметчик',
  departmentEngineer: 'Специалист отдела закупок',
  headMTO: 'Руководитель МТО/ПТО',
  director: 'Руководитель технического (инженерного) отдела',
  expert: 'Эксперт',
  customRole: 'Укажите свою роль',
  company: 'Укажите компанию',
  noCompany: 'Не отношусь к компании',
  welcome: 'Добро пожаловать!',
  welcomeDesc: 'Для завершения регистрации напишите имя в текстовом поле ниже, остальные поля можно проигнорировать, но там есть действительно полезные вещи.',
  whoaYou: 'Кто вы?',
  name: 'Имя',
  lastName: 'Фамилия',
  setAvatar: 'Установите аватарку',
  uploadSelf: 'Загрузить свою',
  setPassword: 'Задайте уникальный пароль',
  passwordDesc: 'Хранить на почте пароль небезопасно, поэтому рекомендуем придумать свой. Обязательно запишите его, после подтверждения старый будет неактивен.',
  password: 'Пароль',
  retryPassword: 'Повторите пароль',
  goodPassword: 'Признаки хорошего пароля:',
  pswd1: 'минимум 8 символов',
  pswd2: 'наличие числа или спецсимвола ($%@_.)',
  pswd3: 'нбез повторяющихся символов',
  delicious: 'Восхитительно!',
  deliciousDesc: 'Надеемся использование сервиса принесет вам только положительные впечатления.',
  youCan: 'Теперь вы можете:',
  can1: 'Публиковать модели в библиотеке наравне с 300 другими производителями',
  can2: 'Создавать статьи для читального зала, используя функциональный редактор',
  can3: 'Просматривать детализированную статистику и узнавать о предпочтениях ваших посетителей',
  start: 'Начать работу',
  chooseLanguage: 'Выберите язык',
  specialisations: [
    'Архитектурные решения',
    'Схема планировочной организации земельного участка',
    'Конструктивные решения',
    'Системы водоснабжения и водоотведения',
    'Системы газоснабжения',
    'Системы отопления, вентиляции и кондиционирования',
    'Системы связи, сигнализации и пожарной безопасности',
    'Системы электроснабжения',
    'Организация строительства',
    'Технологические решения',
  ],
  roles: {
    manufacturer: 'Производитель',
    designer: 'Проектировщик'
  }
}
